import { Button, type ButtonProps as CoreUIButtonProps } from '@eleo-rh/core-ui'

export type ButtonProps = CoreUIButtonProps
export type { CoreUIButtonProps }

export default function CoreUIButton({ styles, ...props }: CoreUIButtonProps) {
  const mergedStyles =
    typeof styles === 'function'
      ? styles
      : {
          ...styles,
          root: {
            width: 'max-content',
            ...styles?.root,
          },
          content: {
            fontWeight: 600,
            fontSize: 12,
            textTransform: 'uppercase',
            ...(styles?.content ?? {}),
          },
        }

  return <Button {...props} styles={mergedStyles} />
}
